/** Public API hostnames (goal state once Cloudflare → Cloud Run proxy is healthy). */
export const PROD_API_ORIGIN = 'https://api.optictruckworks.com'
export const STG_API_ORIGIN = 'https://dev-api.optictruckworks.com'

/**
 * Live Cloud Run URLs (CORS + Socket.IO). Use for browser traffic when custom
 * domains return Cloudflare 404 without API CORS headers.
 */
export const PROD_API_CLOUD_RUN_ORIGIN = 'https://otw-api-prod-m6uviqmkga-uc.a.run.app'
export const STG_API_CLOUD_RUN_ORIGIN = 'https://otw-api-stg-ky2zwlng5a-uc.a.run.app'

export const resolvePortalApiOrigin = (firebaseProjectId?: string): string =>
  firebaseProjectId === 'otw-stg' ? STG_API_CLOUD_RUN_ORIGIN : PROD_API_CLOUD_RUN_ORIGIN
